export default "__VITE_ASSET__656db3e6__"